import { faCircleXmark } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

type ClearButtonProps = {
  size?: 'small' | 'large' | 'jumbo' | 'medium' | 'xl';
};

export const ClearButton = ({ size }: ClearButtonProps) => (
  <FontAwesomeIcon
    icon={faCircleXmark}
    className={clsx(
      'cursor-pointer text-icon-primary hover:text-icon-hover active:text-icon-action',
      size === 'jumbo' ? 'min-h-6 w-6' : 'min-h-5 w-5',
    )}
  />
);
